import React from 'react';
import { useSelector } from 'react-redux';
import { ActionButton, Button, ButtonGroup, Checkbox, Content, Dialog, DialogTrigger, Divider, Flex, Footer, Heading, Text, } from '@adobe/react-spectrum';
import { ProjectActions } from 'app/stores/project/actions';
import { getCurrentPageMarkersCount } from 'app/stores/selectors';
import { useAppDispatch } from 'app/stores/store';
import { Text as CustomText } from 'app/views/components/typography/Text';
const DuplicationDialog = (props) => {
    const { close } = props;
    const dispatch = useAppDispatch();
    const [dontAskAgain, setDontAskAgain] = React.useState(configGet('duplicate-slide-should-ask', true));
    const onProceeed = React.useCallback((keepItems) => {
        configSet('duplicate-slide-should-ask', dontAskAgain);
        dispatch(ProjectActions.clonePage({
            keepItems,
        }));
        close();
    }, [dontAskAgain, close, dispatch]);
    const onYes = React.useCallback(() => {
        onProceeed(true);
    }, [onProceeed]);
    const onNo = React.useCallback(() => {
        onProceeed(false);
    }, [onProceeed]);
    return (React.createElement(Dialog, null,
        React.createElement(Heading, null, "Copy markers to new slide"),
        React.createElement(Divider, null),
        React.createElement(Content, null,
            React.createElement(Flex, { direction: "column", gap: "size-200" },
                React.createElement(Text, null, "Current slide will be cloned. Do you want all markers to be copied to new slide?"),
                React.createElement(CustomText, { size: "XS" }, "This can be changed in editor settings (bottom right)"))),
        React.createElement(Footer, null,
            React.createElement(Checkbox, { isSelected: !dontAskAgain, onChange: value => setDontAskAgain(!value) }, "Do not ask me again")),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { variant: "secondary", onPress: close }, "Cancel"),
            React.createElement(Button, { variant: "primary", onPress: onYes }, "Yes"),
            React.createElement(Button, { variant: "primary", onPress: onNo }, "No"))));
};
const DublicationActionButton = () => {
    const dispatch = useAppDispatch();
    const onDuplicatePage = React.useCallback(() => {
        dispatch(ProjectActions.clonePage({
            keepItems: configGet('slideDuplicateKeepItems', false),
        }));
    }, [dispatch]);
    return (React.createElement(ActionButton, { isQuiet: true, onPress: onDuplicatePage }, "Duplicate Slide"));
};
export const DuplicatePageButton = () => {
    const hasMarkers = useSelector((state) => getCurrentPageMarkersCount(state) > 0);
    const shouldAsk = configGet('duplicate-slide-should-ask', true);
    if (!hasMarkers || !shouldAsk) {
        return React.createElement(DublicationActionButton, null);
    }
    return (React.createElement(DialogTrigger, null,
        React.createElement(ActionButton, { "data-test-id": "header-duplicate-slide", isQuiet: true }, "Duplicate Slide"),
        close => React.createElement(DuplicationDialog, { close: close })));
};
